/**
 * HTML Helper Utilities
 * Collection of HTML manipulation and parsing functions
 */
class htmlHelper {
  /**
   * Strips HTML tags from a string and cleans extra whitespace
   * @param {string} html - HTML string to be stripped
   * @returns {string} Clean plain text string
   */
  static stripHtml(html) {
    if (!html) return '';
    try {
      if (typeof DOMParser !== 'undefined') {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
      }
      return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    } catch (e) {
      return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    }
  }
}

export default htmlHelper;
export { htmlHelper };
